// @flow
// Modules
import styled from 'styled-components';

function getBackgroundColor(props) {
  if (props.dark) {
    return props.theme.palette.text.dark;
  } else {
    return props.color || '#ffffff';
  }
}

const Icon: any = styled.div.attrs((props) => ({
  style: {
    WebkitMaskImage: `url(${props.asset})`,
    maskImage: `url(${props.asset})`
  }
}))`
  width: ${(props) => props.width || props.size || '0.8em'};
  min-width: ${(props) => props.minWidth || props.minSize || '0.8em'};
  height: ${(props) => props.height || props.size || '0.8em'};
  min-height: ${(props) => props.minHeight || props.minSize || '0.8em'};

  mask-position: 30% 50%;
  mask-size: 100% 100%;
  mask-repeat: no-repeat;

  background-color: ${(props) => getBackgroundColor(props)};
`;

export default Icon;
